import { Link } from 'react-router-dom';
import './Legal.css';

export default function Cookies() {
  return (
    <div className="legal-page">
      <article className="legal-article">
        <Link to="/" className="legal-back">
          ← Back to home
        </Link>

        <h1 className="legal-title">Cookie Policy</h1>
        <p className="legal-updated">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' })}
        </p>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Introduction</h2>
            <p>
              The Local Jobs New England North West website ("the Site") is operated on behalf of the Department of
              Employment and Workplace Relations (DEWR) as part of the Australian Government&apos;s Local Jobs Program.
              This Cookie Policy explains how we use cookies and similar technologies when you visit the Site, in
              accordance with the Privacy Act 1988 (Cth) and the Australian Privacy Principles.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. What are cookies?</h2>
            <p>
              Cookies are small text files that are placed on your device when you visit a website. They are widely
              used to make websites work more efficiently, remember your preferences, and provide information to site
              owners. We may also use similar technologies such as local storage for the same purposes.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Types of cookies we use</h2>
            <p>We use the following types of cookies on the Site:</p>
            <ul>
              <li>
                <strong>Essential cookies</strong>, required for the Site to function. These include session
                management, security, and load balancing. They cannot be disabled.
              </li>
              <li>
                <strong>Preference cookies</strong>, remember your choices, such as cookie consent and accessibility
                settings.
              </li>
              <li>
                <strong>Analytics cookies</strong>, help us understand how visitors use the Site (e.g. pages visited,
                time on site). This information is aggregated and used to improve the Site.
              </li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Cookie consent</h2>
            <p>
              When you first visit the Site, you may see cookie controls. You can choose to accept all cookies or
              decline optional cookies. Essential cookies are always active. Your choice is stored locally and can be
              changed by clearing your browser data.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Managing cookies</h2>
            <p>
              You can control and delete cookies through your browser settings. Most browsers allow you to refuse or
              accept cookies, or to delete existing cookies. Blocking or deleting cookies may affect how the Site works
              and your user experience.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Third-party cookies</h2>
            <p>
              The Site may include content or links to third-party services. These third parties may set their own
              cookies. We do not control these cookies. Please review the privacy and cookie policies of any third-party
              sites you access via links from our Site.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Data storage</h2>
            <p>
              Data collected via cookies on this Site is stored and processed in Australia, in accordance with our data
              sovereignty commitments.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Changes</h2>
            <p>
              We may update this Cookie Policy from time to time. The "Last updated" date at the top of this page will
              reflect any changes. We encourage you to review this policy periodically.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Contact</h2>
            <p>
              For questions about our use of cookies, please contact the Local Jobs New England North West team. For
              broader privacy enquiries, see our <Link to="/privacy">Privacy Policy</Link>.
            </p>
          </section>
        </div>
      </article>
    </div>
  );
}
